import {Injectable} from '@angular/core';
import {NavigationSetting, UserSetting} from '@pezi/entities';
import {createStore, withProps} from "@ngneat/elf";
import {localStorageStrategy, persistState, sessionStorageStrategy} from "@ngneat/elf-persist-state";
import {RightUtil} from "@app/core/util/right.util";
import {globalDrawerItems} from "@app/shell/navitems";


@Injectable({providedIn: 'root'})
export class UserSettingsStore {

  constructor(private rightUtil: RightUtil) {
  }

  getDefaultNavigationItems(): NavigationSetting[] {
    return globalDrawerItems
      .filter(item => item.defaultNavBox && this.rightUtil.hasRight(item.right))
      .map(item => {
        return {
          id: item.id,
          icon: item.icon,
          title: item.header,
          rights: item.right.toString(),
          navigate: item.routerUrl
        };
      });
  }

  createInitialState(): UserSetting {
    return {
      navigation: undefined,
      geburtstag: undefined,
    };
  }

  data = createStore({name: 'settings'}, withProps<UserSetting>(this.createInitialState()));
  persist = persistState(this.data, {
    key: 'settings',
    storage: sessionStorageStrategy,
  });

}

